let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iO7VA")).then(() => parcelRequire('4CchY'));